import React from 'react';
import { CheckCircle } from 'lucide-react';
import useScrollReveal from '../hooks/useScrollReveal';

const AboutUs = () => {
  const [ref, revealed] = useScrollReveal(0.15);
  const additionalServices = [
    'Frachtkostenoptimierung',
    'Transportverpackung',
    'Fulfillment',
    'Werbemailing'
  ];

  return (
    <section id="ueber-uns" className="py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div
          ref={ref}
          className={`max-w-4xl mx-auto reveal-on-scroll ${revealed ? 'revealed' : ''}`}
        >
          <h2 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-10 text-center" data-testid="about-heading">
            Über mich
          </h2>

          <div className="bg-slate-50/50 backdrop-blur-sm rounded-lg border border-slate-100 p-8 lg:p-12 shadow-lg hover:shadow-xl transition-all duration-300">
            <p className="text-slate-700 leading-relaxed text-lg mb-6">
              Als Berater und Umsetzungspartner im Bereich der Versandlogistik und Poststellenorganisation verfüge ich über eine langjährige, fundierte Fachexpertise auf dem Gebiet der Briefkonsolidierung. Mein Fokus liegt auf einer strukturierten und transparenten Analyse bestehender Versandstrukturen, um Ineffizienzen beim Einsatz von Portobudgets präzise zu identifizieren. Ziel meiner Arbeit ist es, auf Augenhöhe mit Ihnen realistische Optimierungspotenziale aufzuzeigen und nachhaltige Einsparkonzepte zu entwickeln.
            </p>
            <p className="text-slate-700 leading-relaxed text-lg mb-6">
              Der Unterschied zu einer reinen Beratung: Ich liefere Ihnen kein Konzept ab und verschwinde. Ich begleite die Umstellung persönlich — von der Analyse bis zum stabilen Regelbetrieb. Sie haben durchgehend einen festen Ansprechpartner, der die Umsetzung selbst verantwortet und dranbleibt.
            </p>
            <p className="text-slate-700 leading-relaxed text-lg mb-10">
              Für Themen außerhalb meiner Kernkompetenz — etwa Frachtkosten, Transportverpackung oder Fulfillment — arbeite ich mit ausgewiesenen Fachpartnern zusammen, die ich koordiniere. So bleibt Ihr Ansprechpartner immer derselbe: ich.
            </p>

            <div className="pt-6 border-t border-slate-100">
              <h3 className="text-base font-semibold text-slate-500 mb-5">
                Zusätzlich decke ich folgende Kostenbereiche ab:
              </h3>
              <div className="grid sm:grid-cols-2 gap-3">
                {additionalServices.map((service, index) => (
                  <div key={index} className="flex items-center gap-3 group">
                    <CheckCircle size={20} className="flex-shrink-0 group-hover:text-slate-900 transition-colors" style={{ color: '#FFA266' }} />
                    <span className="text-slate-700 font-medium group-hover:text-slate-900 transition-colors">{service}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
